import React, { useState } from "react";
import { usePush, esIOS, esPWAInstalada, instruccionesBloqueadas } from "../utils/pushNotificaciones";

// Aviso bien visible para que la asistenta / el comprador activen las
// notificaciones del móvil en ESTE dispositivo. No se muestra si ya están activas
// (ni si el navegador no las admite). compacto = versión para dentro de la campana.
export default function AvisoActivarNotificaciones({ user, compacto = false }) {
  const { estado, activar, desactivar, activando, fallo, exito } = usePush(user);
  const [confirmando, setConfirmando] = useState(false);
  const [quitando, setQuitando] = useState(false);
  const quitar = async () => {
    setQuitando(true);
    await desactivar();
    setQuitando(false);
    setConfirmando(false);
  };
  if (estado === "cargando" || estado === "no_soportado") return null;
  if (estado === "activo" && exito) {
    return (
      <div style={{
        background: "linear-gradient(135deg,#ecfdf5,#d1fae5)", border: "3px solid #22c55e", borderRadius: 18,
        padding: compacto ? "12px 14px" : "16px 18px", marginBottom: compacto ? 12 : 18,
        boxShadow: compacto ? "none" : "0 6px 18px rgba(34,197,94,0.25)", textAlign: "left",
        display: "flex", gap: 12, alignItems: "center",
      }}>
        <span style={{ fontSize: compacto ? 28 : 38 }}>✅</span>
        <div>
          <div style={{ fontWeight: 900, color: "#15803d", fontSize: compacto ? 15.5 : 18 }}>¡Notificaciones activadas!</div>
          <div style={{ color: "#166534", fontSize: compacto ? 13.5 : 15, marginTop: 2 }}>
            Te llegará un aviso al móvil cuando cambie algo de tus pisos.
          </div>
        </div>
      </div>
    );
  }
  if (estado === "activo") {
    if (!compacto) return null;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <div style={{ flex: 1, fontSize: 13, color: "#15803d", fontWeight: 700 }}>✅ Avisos al móvil activados en este dispositivo</div>
        <button onClick={() => setConfirmando(true)} style={{
          border: "1px solid #cbd5e1", background: "#fff", color: "#64748b", borderRadius: 8,
          padding: "3px 8px", fontSize: 11.5, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap",
        }}>Desactivar</button>
        {confirmando && (
          <div onClick={() => !quitando && setConfirmando(false)} style={{
            position: "fixed", inset: 0, background: "rgba(15,23,42,0.6)", zIndex: 5000,
            display: "flex", alignItems: "center", justifyContent: "center", padding: 16,
          }}>
            <div onClick={(e) => e.stopPropagation()} style={{
              background: "#fff", borderRadius: 18, border: "4px solid #dc2626", width: "min(420px, 100%)",
              padding: "18px 16px 14px", textAlign: "center", boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
            }}>
              <div style={{ fontSize: 44 }}>⚠️</div>
              <div style={{ fontSize: 20, fontWeight: 900, color: "#b91c1c", marginTop: 4 }}>NO RECOMENDADO</div>
              <div style={{ fontSize: 15.5, color: "#7f1d1d", fontWeight: 700, margin: "10px 0 16px", lineHeight: 1.4 }}>
                Si las desactivas <u>no vas a recibir ningún aviso</u> en el móvil cuando cambie algo de tus pisos (horarios, pisos nuevos, cambios de ruta…).
              </div>
              <button onClick={() => setConfirmando(false)} disabled={quitando} style={{
                width: "100%", border: "none", borderRadius: 12, padding: "13px 0", background: "#16a34a", color: "#fff",
                fontWeight: 900, fontSize: 16, cursor: "pointer", marginBottom: 8,
              }}>Mantener activadas</button>
              <button onClick={quitar} disabled={quitando} style={{
                width: "100%", border: "2px solid #dc2626", borderRadius: 12, padding: "10px 0", background: "#fff", color: "#dc2626",
                fontWeight: 800, fontSize: 14, cursor: "pointer", opacity: quitando ? 0.6 : 1,
              }}>{quitando ? "Desactivando…" : "Sí, desactivar"}</button>
            </div>
          </div>
        )}
      </div>
    );
  }
  // Si las desactivó, dentro de la campana se recuerda en pequeño; en la pantalla
  // principal sigue saliendo el aviso grande (más abajo) para que las vuelva a activar.
  if (estado === "desactivado" && compacto) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10, background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 10, padding: "8px 10px" }}>
        <div style={{ flex: 1, fontSize: 13, color: "#b91c1c", fontWeight: 700 }}>🔕 Has desactivado los avisos al móvil</div>
        <button onClick={activar} disabled={activando} style={{
          border: "none", background: "#ea580c", color: "#fff", borderRadius: 8, padding: "6px 10px",
          fontSize: 13, fontWeight: 800, cursor: "pointer", whiteSpace: "nowrap", opacity: activando ? 0.6 : 1,
        }}>{activando ? "Activando…" : "🔔 Activar"}</button>
      </div>
    );
  }
  const instalar = estado === "instalar" || (esIOS() && !esPWAInstalada());
  const bloqueado = estado === "bloqueado";
  const desactivadas = estado === "desactivado";
  return (
    <div style={{
      background: "linear-gradient(135deg,#fff7ed,#fef3c7)", border: "3px solid #f59e0b", borderRadius: 18,
      padding: compacto ? "12px 14px" : "16px 18px", marginBottom: compacto ? 12 : 18,
      boxShadow: compacto ? "none" : "0 6px 18px rgba(245,158,11,0.25)", textAlign: "left",
    }}>
      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
        <span style={{ fontSize: compacto ? 28 : 38 }}>🔔</span>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 900, color: "#9a3412", fontSize: compacto ? 15.5 : 18 }}>
            {bloqueado ? "Tienes las notificaciones bloqueadas" : desactivadas ? "Has desactivado las notificaciones" : "Activa las notificaciones"}
          </div>
          <div style={{ color: "#7c2d12", fontSize: compacto ? 13.5 : 15, marginTop: 2 }}>
            Así te llegará un aviso al móvil cuando cambie algo de tus pisos (horario, piso nuevo…).
          </div>
        </div>
      </div>
      {fallo && !bloqueado && !instalar ? (
        <div style={{ fontSize: 14, color: "#7c2d12", background: "#fff", borderRadius: 12, padding: "10px 12px", marginTop: 10, fontWeight: 600 }}>
          Tu móvil no ha respondido esta vez. No tienes que hacer nada: lo volveremos a intentar solo cada vez que abras la app.
        </div>
      ) : null}
      {instalar || bloqueado ? (
        <div style={{ whiteSpace: "pre-line", fontSize: 14, color: "#7c2d12", background: "#fff", borderRadius: 12, padding: "10px 12px", marginTop: 10, fontWeight: 600 }}>
          {instruccionesBloqueadas()}
        </div>
      ) : null}
      {!instalar && (
        <button onClick={activar} disabled={activando} style={{
          marginTop: 12, width: "100%", border: "none", borderRadius: 14, padding: compacto ? "11px 0" : "14px 0",
          background: "#ea580c", color: "#fff", fontWeight: 900, fontSize: compacto ? 15.5 : 18, cursor: "pointer", opacity: activando ? 0.6 : 1,
        }}>{activando ? "Activando…" : fallo ? "🔄 Intentar otra vez" : bloqueado ? "🔔 Ya las he permitido, activar" : "🔔 Activar notificaciones"}</button>
      )}
    </div>
  );
}
